export default __webpack_public_path__ + "static/sakhalin-post-5198fafbde63885ea086eb1cca96b58d.jpg";